import { UNIT } from '~/environment-variables/unit.const'

export const DEPLOYED_CONTRACTS_TABLE_COLUMNS = [
  {
    name: 'ADDRESS',
    field: 'address',
  },
  {
    name: 'CONTRACT NAME',
    field: 'contractName',
    isHoverable: true,
  },
  {
    name: 'COMPILER',
    field: 'compiler',
    isHoverable: true,
  },
  {
    name: 'VERSION',
    field: 'compilerVersion',
    isHoverable: true,
  },
  {
    name: 'BALANCE',
    field: 'balance',
    isHoverable: true,
    unit: UNIT,
  },
  {
    name: 'TRANSACTIONS',
    field: 'transactionCount',
    isHoverable: true,
  },
  {
    name: 'DEPLOYED',
    field: 'deployedDate',
    isHoverable: true,
  },
]